<template>
  <div>
    <b-row :style="{marginBottom: '18px'}">
      <b-col>
        <el-date-picker v-model="selectedDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" :picker-options="pickerOptions" />
      </b-col>
    </b-row>
    <b-table class="text-center" show-empty responsive="sm" :items="items" :fields="fields" :emptyText="tableEmptyText">
      <template #cell(top_id)="data">
        <span v-if="data.item.top_id !== 0">{{ data.item.top_id }}</span>
        <span v-else>其余总和</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'item-top',
  mixins: [Error],
  props: ['appId', 'oversea', 'startTime', 'endTime'],
  data () {
    let that = this
    return {
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      selectedDate: '',
      items: [],
      fields: consts.VOTE_ITEM_TOP_FIELDS,
      pickerOptions: {
        disabledDate (time) {
          return that.judgeDate(time)
        }
      },
      st: new Date(this.startTime.split(' ')[0] + ' 00:00:00'),
      et: new Date(this.endTime),
      ct: new Date()
    }
  },
  watch: {
    selectedDate (val) {
      this.getData()
    }
  },
  methods: {
    getData () {
      let params = {
        app_id: this.appId,
        date: this.selectedDate
      }
      let reqData = {
        path: api.getVoteItemTopStatistics(),
        type: this.oversea ? consts.OVERSEA_TYPE : process.env.NODE_ENV.slice(0, 3),
        method: 'GET',
        data: params
      }
      this.$ajax.post(api.getBaseUrl() + 'vote_project', reqData).then((res) => {
        if (res.success) {
          this.items = res.data.top_list
          if (res.data.top_list.length === 0) {
            this.$message('当天无投票记录')
          }
        } else {
          this.handleError(res)
        }
      }, (res) => {
        this.handleError(res)
      })
    },
    judgeDate (time) {
      return time.getTime() < this.st.getTime() || time.getTime() > (this.ct.getTime() > this.et.getTime() ? this.et.getTime() : this.ct.getTime())
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ItemTop.vue?683e5fa5